import { render, staticRenderFns } from "./CustomSelectBox.vue?vue&type=template&id=3731aaa4&scoped=true&"
import script from "./CustomSelectBox.vue?vue&type=script&lang=ts&"
export * from "./CustomSelectBox.vue?vue&type=script&lang=ts&"
import style0 from "./CustomSelectBox.vue?vue&type=style&index=0&id=3731aaa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3731aaa4",
  null
  
)

export default component.exports